import { FC, ReactNode } from "react";

import {
  MarkdownDivWithReferences,
  MarkdownReference,
} from "@tsmono/react/components";

interface ExplanationProps {
  explanation?: string;
  references?: MarkdownReference[];
  options?: {
    previewRefsOnHover?: boolean;
  };
}

export const Explanation: FC<ExplanationProps> = ({
  explanation,
  references,
  options,
}): ReactNode => {
  return (
    <MarkdownDivWithReferences
      markdown={explanation ?? ""}
      references={references}
      options={options}
    />
  );
};
